/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_CloseInputs */

const en_mk_nav_close = /** @type {(inputs: Mk_Nav_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const id_mk_nav_close = /** @type {(inputs: Mk_Nav_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Mk_Nav_CloseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_close = /** @type {((inputs?: Mk_Nav_CloseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_CloseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_close(inputs)
	return en_mk_nav_close(inputs)
});